<template>
  <div class="internetBuyCardOrderDetail">
    <!-- <div>互联网购卡订单详情</div> -->

    <!-- 订单详情 -->
    <div class="orderDeWrap">
      <!-- 标题 -->
      <title-box :top-title="topTitle"></title-box>

      <!-- 内容 -->
      <div class="orderDeCon">
        <div class="orderDeTopC flex-row jus-b">
          <!-- 订单状态 -->
          <order-state1 :order-item="currentOrder" :order-state="step" v-if="currentOrder.receive_way==1"></order-state1>
          <order-state2 :order-item="currentOrder" :order-state="step" v-if="currentOrder.receive_way!=1"></order-state2>

          <!-- 流程 -->
          <!-- <order-step :order-item="currentOrder" :order-state="step"></order-step> -->
          <order-step1 :order-item="currentOrder" :order-state="step" v-if="currentOrder.receive_way==1"></order-step1>
          <order-step2 :order-item="currentOrder" :order-state="step" v-if="currentOrder.receive_way!=1"></order-step2>
        </div>

        <div class="orderDeBotpC flex-row jus-b">
          <!-- 订单信息 -->
          <order-info :order-item="currentOrder" :order-state="step"></order-info>

          <!-- 客户信息 -->
          <customer-info :order-item="currentOrder" :order-state="step"></customer-info>

          <!-- 物流信息 -->
          <!-- <logistics :order-item="currentOrder" :order-state="step"></logistics> -->
          <logistics :order-item="currentOrder" :order-state="step" v-if="currentOrder.receive_way==1"></logistics>
          <logistics-empty :order-item="currentOrder" :order-state="step" v-if="currentOrder.receive_way!=1"></logistics-empty>
        </div>
      </div>

      <!-- 商品信息 -->
      <div class="goodsWrap">
        <goods-info :order-item="currentOrder" ></goods-info>
      </div>
    </div>

    <!-- 弹层 -->
    <remarks v-show="offon"></remarks>

  </div>
</template>

<script>
  import TitleBox from '@/components/Common/TitleBox/TitleBox.1';
  import orderState1 from './components/OrderState.1';
  import orderState2 from './components/OrderState.2';
  import orderStep1 from './components/OrderStep.1';
  import orderStep2 from './components/OrderStep.2';
  import orderInfo from './components/OrderInfo';
  import customerInfo from './components/CustomerInfo';
  import logistics from './components/Logistics';
  import logisticsEmpty from './components/LogisticsEmpty';
  import goodsInfo from './components/GoodsInfo';

  import remarks from './components/Remarks';
  import {getOrderDetailReq} from '@/api/Order/NumCardOrder/internetBuyCardOrder.js';

  export default {
    name: "internetBuyCardOrderDetail",
    data() {
      return {
        //标题
        topTitle: {
          title: '',
          subTit: '查看订单详情'
        },
        step: 3,
        offon: false,
        currentOrder: {

        }
      }
    },
    created() {
      this.initOrderDetail()
    },
    methods: {
      initOrderDetail() {
        const id = this.$route.query.id;
        getOrderDetailReq({id: id})
            .then(resp => {
              this.currentOrder = JSON.parse(unescape(JSON.stringify(resp.body)))
              if(resp.body.receive_way_name)
                this.topTitle.title = "互联网购卡";
              else
                this.topTitle.title = "现场购卡";
            })
            .catch(e => console.log(e));
      }
      
    },
    components: {
      TitleBox,
      orderState1,
      orderState2,
      orderStep1,
      orderStep2,
      orderInfo,
      customerInfo,
      logistics,
      logisticsEmpty,
      goodsInfo,
      remarks
    }
  }
</script>

<style scoped>
  .internetBuyCardOrderDetail {
    /* height: auto; */
    /* min-width: 1100px; */
    /* min-width: 1056px; */
    min-width: 1090px;
  }

  .orderDeCon {
    margin-top: 15px;
  }

  .orderDeBotpC {
    margin-top: 12px;
  }

  .goodsWrap {
    padding: 14px 14px 15px;
    margin-top: 13px;
    background: #fff;
  }
</style>
